import { FormProvider } from 'forms';
import React from 'react';
import KnowMoreView from '../KnowMoreView/KnowMoreView';
import EditOvertimeForm from './EditOvertimeForm';

const EditOvertime = () => {
  return (
    <FormProvider>
      <EditOvertimeForm />
      <KnowMoreView />
    </FormProvider>
  );
};

export default EditOvertime;
